"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveEffectivePermissions = exports.INITIAL_VISIBLE_ROLE_COLUMNS = exports.roleColumns = exports.INITIAL_VISIBLE_COLUMNS = exports.userColumns = exports.validationConfig = exports.statusOptions = exports.accountTypeOptions = exports.initialUserUpdateValues = exports.initialUserValues = exports.initialPermissionsValues = exports.featurePermissions = exports.userBranchTableColumns = exports.tableColumns = void 0;
var user_1 = require("../../../../reducers/slices/user/user");
var constants_1 = require("../../constants");
exports.tableColumns = [
    {
        displayKey: "name",
        label: "Name",
    },
    {
        displayKey: "surname",
        label: "Surname",
    },
    {
        displayKey: "cell_number",
        label: "Phone Number",
    },
    {
        displayKey: "email",
        label: "Email",
    },
    {
        displayKey: "role",
        label: "Account Type",
    },
    {
        displayKey: "status",
        label: "Status",
        formatter: function (x) {
            if (x) {
                return (0, constants_1.TABLE_STATUSES)(x.status);
            }
        },
    },
];
exports.userBranchTableColumns = [
    {
        displayKey: "branch_number",
        label: "Branch Number",
    },
    {
        displayKey: "branch_name",
        label: "Branch Name",
    },
    {
        displayKey: "phone",
        label: "Phone",
    },
    {
        displayKey: "email",
        label: "Email",
    },
    {
        displayKey: "total_revenue",
        label: "Total Revenue",
    },
    {
        displayKey: "average_monthly_revenue",
        label: "Average Monthly Revenue",
    },
    {
        displayKey: "deliveries",
        label: "Deliveries",
    },
    {
        displayKey: "status",
        label: "Status",
    },
];
exports.featurePermissions = {
    BADGES: "Badges",
    CHALLENGES: "Challenges",
    REWARD_TRACKS: "Reward Tracks",
    ECONOMICS: "Economics",
    WALLET: "Currencies",
    CASHBACK: "Cashback",
    XP_POINTS: "XP Points",
    TRANSACTIONS: "Transactions",
    CUSTOMERS: "Customers",
    STATISTICS: "Statistics",
    SEGMENTS: "Segments",
    EVENT_TYPES: "Event Types",
    USERS: "Users",
};
var initialPermissionsValues = function () {
    // every feature gets its own object, since a shared one would let one toggle write through to all rows
    var permissions = {};
    Object.keys(exports.featurePermissions).forEach(function (feature) {
        permissions[feature] = { read: false, create: false, update: false, delete: false };
    });
    return permissions;
};
exports.initialPermissionsValues = initialPermissionsValues;
exports.initialUserValues = {
    name: user_1.devMode ? "John" : "",
    surname: user_1.devMode ? "Doe" : "",
    password: user_1.devMode ? "12345" : "",
    user_name: user_1.devMode ? "John" : "",
    cell_number: user_1.devMode ? "123-456-7890" : "",
    email: user_1.devMode ? "johndoe@example.com" : "",
    role: "ADMIN",
    status: user_1.devMode ? "ACTIVE" : "",
    manager_of: [],
    user_permissions: (0, exports.initialPermissionsValues)(),
    get_communication: false,
    agrees_terms_and_conditions: true,
};
// There's probably a better way to approach this, but we
// need to somehow make provisions for users that were previously
// created without fields like user_permissions
exports.initialUserUpdateValues = {
    status: "ACTIVE",
    manager_of: [],
    user_permissions: (0, exports.initialPermissionsValues)(),
};
exports.accountTypeOptions = [
    { label: "Admin", value: "ADMIN" },
    { label: "Area Manager", value: "AREA_MANAGER" },
    { label: "Branch Manager", value: "BRANCH_MANAGER" },
    { label: "Custom", value: "CUSTOM" },
];
exports.statusOptions = [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
];
exports.validationConfig = {
    manager_of: { dependOn: { key: "role", value: ["BRANCH_MANAGER", "AREA_MANAGER"] } },
};
exports.userColumns = [
    { name: "Name", uid: "name", sortable: true },
    { name: "Surname", uid: "surname", sortable: true },
    { name: "Phone Number", uid: "cell_number" },
    { name: "Email", uid: "email", sortable: true },
    { name: "Role", uid: "role_name", sortable: true },
    { name: "Status", uid: "status", sortable: true },
    { name: "Actions", uid: "actions" },
];
exports.INITIAL_VISIBLE_COLUMNS = ["name", "surname", "cell_number", "email", "role_name", "status", "actions"];
exports.roleColumns = [
    { name: "Role", uid: "name", sortable: true },
    { name: "Type", uid: "role_type" },
    { name: "Assigned Users", uid: "assigned_user_count" },
    { name: "Actions", uid: "actions" },
];
exports.INITIAL_VISIBLE_ROLE_COLUMNS = ["name", "role_type", "assigned_user_count", "actions"];
// mirrors the service: a feature missing from a record follows its role, and a missing role entry is on for Admin and off otherwise
var resolveEffectivePermissions = function (isAdmin, rolePermissions, userPermissions) {
    var resolved = {};
    Object.keys(exports.featurePermissions).forEach(function (feature) {
        resolved[feature] = { read: isAdmin, create: isAdmin, update: isAdmin, delete: isAdmin };
    });
    return __assign(__assign(__assign({}, resolved), rolePermissions), userPermissions);
};
exports.resolveEffectivePermissions = resolveEffectivePermissions;
